import DDModal from 'src/pc/components/DDModal'
import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import DDButton from 'src/pc/components/DDButton'
import { DWgetWechatRefundConfig } from 'src/commons/store/UserStore'
import { CheckCircleFilled } from '@ant-design/icons'
import { observer } from 'mobx-react'
import { hot } from 'react-hot-loader/root'
import { useHistory } from 'react-router-dom'
import { AppStore } from 'src/pc/store/AppStore'
import { getContact } from 'src/pc/store/UIController'

const StartProblem: React.FC<{
  visible: boolean
  onCancel: () => void
  order?: OrderInfo
}> = ({ visible, onCancel, order }) => {
  const [selected, setSelected] = useState(1)
  const [timeout, setTimeout] = useState<string>()
  const history = useHistory()

  const onConfirm = () => {
    onCancel()
    AppStore.realNameAuthModal = false
    if (selected === 0 && order) {
      history.push(`/User/order`)
      AppStore.fastRefundFinalVisible = true
      AppStore.fastRefundOrder = {
        ...order,
        order_no: order.orderNo,
      }
      return
    }
    getContact()
  }
  useEffect(() => {
    if (visible) {
      DWgetWechatRefundConfig.Execute().then(res => {
        setTimeout(res.timeout)
      })
    }
  }, [visible])

  useEffect(() => {
    !visible && setSelected(1)
  }, [visible])

  return (
    <DDModal
      visible={visible}
      onCancel={onCancel}
      footer={false}
      centered={true}
      width={600}
      maskClosable={false}
      zIndex={1009}
    >
      <StyledRefundAndExchange>
        <StyledTitle>启动游戏遇到问题？</StyledTitle>
        <StyledSelect>
          <StyledOption active={selected === 0} onClick={() => setSelected(0)}>
            <StyledText>极速退款</StyledText>
            <StyledDescription>购买{timeout}小时内，可申请极速退款哦</StyledDescription>
            <StyleCheckCircleFilled active={selected === 0 ? 1 : 0} />
          </StyledOption>
          <StyledOption active={selected === 1} onClick={() => setSelected(1)}>
            <StyledText>人工在线客服</StyledText>
            <StyledDescription>解决售后、退款、上号、存档、游戏安装、游戏加速等问题</StyledDescription>
            <StyleCheckCircleFilled active={selected === 1 ? 1 : 0} />
          </StyledOption>
        </StyledSelect>
        <StyledButton type="primary" onClick={onConfirm}>
          确定
        </StyledButton>
      </StyledRefundAndExchange>
    </DDModal>
  )
}

const StyledButton = styled(DDButton)`
  margin: 0 auto;
  display: block;
  width: 168px;
  height: 44px;
  font-size: 16px;
`

const StyledDescription = styled.div`
  min-height: 44px;
  line-height: 22px;
  display: flex;
  align-items: center;
  font-size: 14px;
`

const StyledText = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`

const StyleCheckCircleFilled = styled(CheckCircleFilled)<{ active: number }>`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 22px;
  //color: #495055;
  color: ${props => {
    return props.active ? 'var(--main-color)' : '#495055'
  }};
`

const StyledOption = styled.div<{ active: boolean }>`
  width: 236px;
  height: 140px;
  border-radius: 6px;
  background: #343a3f;
  padding: 16px 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  margin: 0 10px;
  cursor: pointer;
  position: relative;
  border: ${props => {
    return props.active ? '2px solid var(--main-color)' : '2px solid #42494E'
  }};
`

const StyledSelect = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 33px;
`

const StyledTitle = styled.div`
  text-align: center;
  font-size: 18px;
  margin-bottom: 30px;
  line-height: 1;
  padding-top: 10px;
`

const StyledRefundAndExchange = styled.div`
  color: #fff;
  padding-bottom: 10px;
`

export default hot(observer(StartProblem))
